import React from 'react';
import './code_editor.css';

interface Props {
  value: string;
  placeholder?: string;
  onChange?: React.ChangeEventHandler<HTMLTextAreaElement>;
  autofocus?: boolean;
}

export function CodeEditor({ value, placeholder, onChange, autofocus }: Props): JSX.Element {
  return (
    <textarea
      className="code-editor"
      value={value}
      placeholder={placeholder}
      onChange={onChange}
      autoFocus={autofocus}
    />
  );
}
